import { z } from 'zod'

export const candidateSources = [
  'referral',
  'job_board',
  'agency',
  'direct',
  'other',
  'online_application',
] as const

export type CandidateSource = (typeof candidateSources)[number]

/**
 * The board's URL search params (apps/company/AGENTS.md: filters live in the
 * URL so a view is linkable and survives reload). `opening_id` absent means
 * "the default opening", which the screen
 * derives rather than the schema — the screen renders the first opening while
 * the list loads, so the URL never lies about a row that is not there yet.
 */
export const boardSearchSchema = z.object({
  opening_id: z.string().optional(),
  source: z.enum(candidateSources).optional(),
  create: z.literal('opening').optional(),
  // A hidden stage's column disappears from the board by default — with any
  // candidate already in it (docs/architecture/0023, ticket 04). This switch
  // reveals it, the same "Show hidden" the stage settings list carries.
  show_hidden: z.boolean().optional(),
})

export type BoardSearch = z.infer<typeof boardSearchSchema>
